import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import {
  getStatusCss,
  RemarkBodyTemplate,
  docBodyTemplate,
} from "../../../Layout/Master/MasterUtils/MasterFormUtils";
import { useTranslation } from "react-i18next";

const dropdownRowFilterTemplate = (data, key) => {
  let dropdownFilterOptions = [];
  if (data && Array.isArray(data)) {
    data.forEach((el) => {
      if (el[key]) dropdownFilterOptions.push(el[key]);
    });
  }
  dropdownFilterOptions = [...new Set(dropdownFilterOptions)];

  return (options) => {
    return (
      <Dropdown
        value={options.value}
        options={dropdownFilterOptions}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder="Select"
        showClear
        className="cockpit-filter-dropdown"
      />
    );
  };
};

const statusItemTemplate = (option) => {
  return (
    <p style={{ color: getStatusCss(option), fontWeight: 600 }}> {option} </p>
  );
};

const statusRowFilterTemplate = () => (options) => {
  const statuses = ["Valid", "Invalid"];
  const { t } = useTranslation("master");
  return (
    <Dropdown
      value={options.value}
      options={statuses}
      onChange={(e) => options.filterApplyCallback(e.value)}
      itemTemplate={statusItemTemplate}
      placeholder={t("Select")}
      showClear
      className="cockpit-filter-dropdown"
    />
  );
};

const serachFilter = () => (options) => {
  const { t } = useTranslation("master");
  return (
    <div className="p-input-icon-right">
      <i
        className="pi pi-search cockpit-custom-search-icon"
        style={{ marginLeft: "8px" }} // Add space to the left
      />

      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.filterApplyCallback(e.target.value)}
        placeholder={t("Search")}
        className="p-column-filter"
        style={{ paddingLeft: "34px" }} // Adjust the padding value as needed
      />
    </div>
  );
};

export const availableFilters = {
  search: serachFilter,
  status: statusRowFilterTemplate,
  dropdown: dropdownRowFilterTemplate,
};

/**Body methods */

const statusBodyTemplate = (rowData) => {
  return (
    <p style={{ color: getStatusCss(rowData.status), fontWeight: 600 }}>
      {" "}
      {rowData.status}{" "}
    </p>
  );
};

export const bodyMethods = {
  remarks: RemarkBodyTemplate,
  status: statusBodyTemplate,
  attachedDoc: docBodyTemplate,
};
